import { http } from '.';

export interface BroadcastNotificationRequest {
  message: string;           // Required: The notification message (max 500 chars)
  batch_size?: number;       // Optional: Batch size (1-5000, default: 1000)
  dry_run?: boolean;         // Optional: Preview mode (default: false)
}

export interface DryRunResponse {
  success: true;
  dry_run: true;
  message: "Dry run completed - no notifications were sent";
  preview: {
    total_devices: number;
    batch_size: number;
    total_batches: number;
    notification_message: string;
  };
}

export interface SuccessResponse {
  success: true;
  message: "Broadcast notification completed";
  summary: {
    total_devices: number;
    total_batches: number;
    successful_notifications: number;
    failed_notifications: number;
    success_rate: number;     // Percentage (0-100)
  };
  status: "completed_successfully";
}

export interface SuccessWithErrorsResponse {
  success: true;
  message: "Broadcast notification completed";
  summary: {
    total_devices: number;
    total_batches: number;
    successful_notifications: number;
    failed_notifications: number;
    success_rate: number;
  };
  status: "completed_with_errors";
  errors: {
    failed_batches: number;
    batch_details: Array<{
      batch: number;
      status: "failed";
      device_count: number;
      error: string;
    }>;
    additional_failures?: number;  // If more than 5 failed batches
  };
}

export interface ErrorResponse {
  success: false;
  error: string;
  total_devices: number;
}

export type BroadcastNotificationResponse = 
  | DryRunResponse 
  | SuccessResponse 
  | SuccessWithErrorsResponse 
  | ErrorResponse;

export async function broadcastNotification({
  message,
  batch_size,
  dry_run,
}: BroadcastNotificationRequest): Promise<BroadcastNotificationResponse> {
  console.log("📡 [Backend Call] Broadcasting notification:", {
    message,
    batch_size,
    dry_run,
  });

  const payload: any = { message };
  
  if (batch_size !== undefined) {
    payload.batch_size = batch_size;
  }
  if (dry_run !== undefined) {
    payload.dry_run = dry_run;
  }

  const response = await http.post<BroadcastNotificationResponse>('/broadcast-notification/', payload);

  console.log("📡 [Backend Response] Broadcast notification response:", response);
  return response;
}
